module.exports = __webpack_public_path__ + "img/3.5abfdc17.png";